import style from './KnowYourCustomerSkeleton.css';
import ArrayUtils from '../../utils/array.utils';
import Skeleton from '../../components/shared/Skeleton/Skeleton';
import AppBar from '../../components/shared/AppBar/AppBar';

export default function KnowYourCustomerSkeleton({
  onCloseClick,
  onBackClick,
  backRef = null,
  closeRef = null,
}) {
  return (
    <div className={style.main}>
      <AppBar
        onBackClick={onBackClick}
        onCloseClick={onCloseClick}
        className={'fixed-bar'}
        backRef={backRef}
        closeRef={closeRef}
      />
      <div className={style.content}>
        <div className={style.image}>
          <Skeleton width="160px" height="160px" radius="50%" />
        </div>

        <div className={style.title}>
          <Skeleton
            className={style['title-line']}
            width="283px"
            height="24px"
            radius="24px"
          />
          <Skeleton
            className={style['title-line']}
            width="160px"
            height="24px"
            radius="24px"
          />
        </div>

        <div className={style.info}>
          {ArrayUtils.range(3).map(el => (
            <div className={style.block} key={el}>
              <Skeleton
                className={style['block-image']}
                width="80px"
                height="80px"
                radius="50%"
              />
              <Skeleton
                width="64px"
                height="12px"
                radius="15px"
                className={style['block-text']}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={'fixed-cta'}>
        <Skeleton width="100%" height="48px" radius="24px" />
      </div>
    </div>
  );
}
